import { Icon } from "@mui/material";

const tabButtonSx: React.CSSProperties = {
  width: 52,
  minWidth: 52,
  border: 0,
  borderLeft: "1px solid #E5E7EB",
  background: "#fff",
  color: "#0F172A",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "6px",
  padding: "12px 8px",
};

const labelSx: React.CSSProperties = {
  writingMode: "vertical-rl",
  textOrientation: "mixed",
  fontSize: "12px",
  fontWeight: 700,
  letterSpacing: "0.04em",
  textTransform: "uppercase",
};

type SidebarToggleTabProps = {
  isOpen: boolean;
  onToggle: () => void;
};

export default function SidebarToggleTab({ isOpen, onToggle }: SidebarToggleTabProps) {
  return (
    <button type="button" onClick={onToggle} style={tabButtonSx}>
      <Icon sx={{ fontSize: 18 }}>{isOpen ? "chevron_right" : "chevron_left"}</Icon>
      <span style={labelSx}>Assign Measurements</span>
    </button>
  );
}
